<template>
  <header>
    <span class="title">
      <i class="el-icon-s-flag"></i>
      {{ $t(`menu.${menuTitle}`) }}
    </span>
    <span class="dropdown">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link"
          >{{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
<!--          <el-dropdown-item @click.native="$router.push('/login')"-->
<!--            >登 出</el-dropdown-item-->
<!--          >-->
          <el-dropdown-item @click.native="logout" divided
            >退 出</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </header>
</template>
<script>
import Cookies from "js-cookie";

export default {
  name: "Header",
  computed: {
    menuTitle() {
      return this.$store.getters.menuTitle.split('-')[0];
    }
  },
  data() {
    return {
      username: localStorage.getItem("userName")
    };
  },
  methods: {
    logout() {
      this.$store.commit("setToken", "");
      this.$store.commit("setAccount", "");
      Cookies.set("token", "");
      Cookies.set("account", "");
      this.$router.push("/login")
    }
  }
};
</script>
<style lang="sass" scoped>
header
  height: 60px
  width: 100%
  background: #fff
  box-shadow: 0 3px 3px rgba(0, 0, 0, .15)
  line-height: 60px
  padding: 0 20px
  .title
    color: #ababab
    font-size: 18px
  .dropdown
    cursor: pointer
    float: right
    margin-right: 50px
    user-select: none
</style>



// WEBPACK FOOTER //
// src/pages/layout/Header.vue